// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import ModalStore from './stores/ModalStore';
import UserStore from './stores/UserStore';
import MessageStore from './stores/MessageStore';
import CompenentStore from './stores/ComponentStore';

const stores = {
    modalStore: ModalStore,
    userStore: UserStore,
    messageStore: MessageStore,
    componentStore: CompenentStore
}

export default stores;